import { render, staticRenderFns } from "./PaymentInfoGroupedSummary.vue?vue&type=template&id=2f46d152&scoped=true"
import script from "./PaymentInfoGroupedSummary.vue?vue&type=script&lang=js"
export * from "./PaymentInfoGroupedSummary.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoGroupedSummary.vue?vue&type=style&index=0&id=2f46d152&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46d152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f46d152')) {
      api.createRecord('2f46d152', component.options)
    } else {
      api.reload('2f46d152', component.options)
    }
    module.hot.accept("./PaymentInfoGroupedSummary.vue?vue&type=template&id=2f46d152&scoped=true", function () {
      api.rerender('2f46d152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentInfoGroupedSummary.vue"
export default component.exports